import {
  ArrowLeftCircle,
  InfoEmpty,
  MessageText,
  MoreHorizCircle,
  Trash,
} from 'iconoir-react'
import React, { memo, useEffect, useMemo, useRef, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import PDFViewer from '../../components/PDFViewer/PDFViewer'
import { getExtensionFile, getNameInCapitalize } from '../../utils/common'
import { useMediaQuery } from 'react-responsive'
import moment from 'moment'
import { DATE_FORMAT_DEFAULT } from '../../utils/constants'
import { EmptyText } from '../../components/common/CellText'
import FileItem from '../../components/FileItemComponent/FileItem'
import { Menu, MenuItem, useTheme } from '@mui/material'
import AlertDialog from '../../components/common/AlertDialog'
import {
  AiOutlineComment,
  AiOutlineEdit,
  AiOutlineDelete,
  AiOutlineQuestionCircle,
} from 'react-icons/ai'
import { Tag } from '../InternalConnectedDocumentIncoming/InternalConnectedDocumentStyled'

const InternalConnectedDocumentOutgoingDetail = props => {
  const { commonStore, loadingAnimationStore, internalConnectedDocumentStore } =
    props
  const [
    selectedInternalConnectedDocumentOutgoing,
    setSelectedInternalConnectedDocumentOutgoing,
  ] = useState(null)
  const { documentId } = useParams()
  const [open, setOpen] = React.useState(false)
  const navigate = useNavigate()
  const [attachmentForView, setAttachmentForView] = useState()
  const commentRef = useRef(null)
  const [openCmtDel, setOpenCmtDel] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingCmt, setLoadingCmt] = useState(false)
  const [deleteItem, setDeleteItem] = useState({
    open: false,
    id_comment: '',
  })
  const opens = Boolean(anchorEl)
  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  useEffect(() => {
    if (!selectedInternalConnectedDocumentOutgoing?.attachments) return
    setAttachmentForView(
      selectedInternalConnectedDocumentOutgoing?.attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(getExtensionFile(file.name))
      )
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInternalConnectedDocumentOutgoing?.attachments])

  const theme = useTheme()
  const renderAttachment = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.id}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={getExtensionFile(attachmentForView?.name)}
      />
    ),
    [attachmentForView]
  )
  const getInternalConnectedDocumentOutgoingById = async documentId => {
    await internalConnectedDocumentStore
      .getInternalConnectedDocumentOutgoingById(documentId)
      .then(response => {
        setSelectedInternalConnectedDocumentOutgoing(response.data)
      })[documentId]
  }
  useEffect(() => {
    ;(async () => {
      try {
        getInternalConnectedDocumentOutgoingById(documentId)
      } catch (err) {
        navigate('/internal-connected-document/outgoing-document')
        console.log(err)
      } finally {
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentId])
  const handleClickOpenInfo = e => {
    e.stopPropagation()
    setOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const handleCloseInfo = () => {
    setOpen(false)
    document.body.style.overflow = 'auto'
  }

  const executeScroll = () => commentRef.current.scrollIntoView()

  const descriptionElementRef = useRef(null)
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <div style={{ background: theme.background.base }}>
      <div
        className="flex items-center p-[20px] gap-[22px]"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}>
        <ArrowLeftCircle
          className="flex-shrink-0"
          onClick={() => {
            navigate(-1)
          }}
        />
        <span
          className="font-bold text-[28px] leading-[29px] "
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
            whiteSpace: 'nowrap',
            marginRight: '5px',
            lineHeight: '35px',
          }}>
          {selectedInternalConnectedDocumentOutgoing?.title}
        </span>
      </div>
      <div className="py-[20px] ">
        <div className={`px-5 }`}>
          <div className="flex justify-between">
            <div
              className="flex justify-center gap-x-2 items-center mt-5 bg-[rgba(0,115,199,0.07);] py-[10px] w-[calc(50%-10px)] text-primary px-[14px] rounded-full text-sm leading-5 cursor-pointer font-medium"
              onClick={handleClickOpenInfo}>
              <div>
                <InfoEmpty />
              </div>
              <span onClick={handleClickOpenInfo}>Thông tin</span>
            </div>
          </div>
          <div className="!w-[100%] mt-[14px] pb-[10px] ">
            {renderAttachment}
          </div>
        </div>

        <Dialog
          open={open}
          onClose={handleCloseInfo}
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="doc-popup"
          fullWidth
          sx={{
            '& .MuiDialog-container': {
              '& .MuiPaper-root': {
                width: '100vw',
                maxWidth: '100vw', // Set your width here
                mx: 0,
              },
            },
          }}>
          <DialogTitle
            id="scroll-dialog-title"
            className="text-xl font-bold text-[#23374D] !py-9"
            sx={{
              fontWeight: 700,
            }}>
            <span className="font-bold">Thông tin</span>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}
              className="">
              <table
                style={{ color: '#16192C' }}
                className="doc-table-vertical font-semibold text-sm leading-5 text-[#16192C]">
                <tr>
                  <th style={{ paddingBottom: 14 }}>Số hiệu:</th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {selectedInternalConnectedDocumentOutgoing?.documentNumber &&
                      selectedInternalConnectedDocumentOutgoing?.documentNumber}
                  </td>
                </tr>

                <tr>
                  <th style={{ paddingBottom: 14 }}>Ngày đi: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {selectedInternalConnectedDocumentOutgoing?.outgoingDate ? (
                      <>
                        <span>
                          {moment(
                            selectedInternalConnectedDocumentOutgoing?.outgoingDate
                          ).format(DATE_FORMAT_DEFAULT)}
                        </span>
                      </>
                    ) : (
                      <EmptyText>Không rõ ngày gửi.</EmptyText>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Tài liệu đính kèm: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {selectedInternalConnectedDocumentOutgoing?.attachments
                      ?.length ? (
                      selectedInternalConnectedDocumentOutgoing?.attachments.map(
                        file => (
                          <FileItem
                            file={file}
                            key={file.id}
                            file_id={file.id}
                            file_name={file.name}
                            file_type={getExtensionFile(file.name)}
                          />
                        )
                      )
                    ) : (
                      <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Nơi nhận: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {selectedInternalConnectedDocumentOutgoing
                      ?.companyRecipients.length !== 0 ? (
                      selectedInternalConnectedDocumentOutgoing?.companyRecipients.map(
                        company => (
                          <Tag
                            color="blue"
                            title={company?.name}
                            key={company.code}>
                            {company?.name}
                          </Tag>
                        )
                      )
                    ) : (
                      <EmptyText>Không có nơi nhận</EmptyText>
                    )}
                  </td>
                </tr>
              </table>
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              sx={{ fontWeight: 600 }}
              onClick={handleCloseInfo}
              className="pb-6 text-sm font-semibold leading-5 text-primary">
              Đóng
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  )
}

export default memo(
  inject('internalConnectedDocumentStore')(
    observer(InternalConnectedDocumentOutgoingDetail)
  )
)
